import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {SharedModule} from '../shared/shared.module';
import {BLUECHAT_ROUTES} from './bluechat.routes';
import {BluechatService} from './bluechat.service';
import {BluechatListComponent} from './search/bluechat-list/bluechat-list.component';
import {BluechatCarriersUnknownComponent} from './search/bluechat-carriers-unknown/bluechat-carriers-unknown.component';
import {BluechatFiltersComponent} from './search/bluechat-filters/bluechat-filters.component';
import {BluechatLoadComponent} from './search/bluechat-load/bluechat-load.component';
import {BluechatLoadStatusComponent} from './search/bluechat-load-status/bluechat-load-status.component';
import {BluechatDeliveryComponent} from './search/bluechat-delivery/bluechat-delivery.component';
import {BluechatNoteCreationComponent} from './components/bluechat-note-creation/bluechat-note-creation.component';
import {BluechatMassCreationNoteComponent} from './components/bluechat-mass-creation/bluechat-mass-creation-note.component';
import {BluechatCarrierDeliveryListComponent} from './components/bluechat-carrier-delivery-list/bluechat-carrier-delivery-list.component';
import {BluechatSearchComponent} from './search/bluechat-search.component';
import {QuillModule} from 'ngx-quill';
import { LoadManagementService } from './shared/load-management.service';
import { BluechatDeliveryListComponent } from './components/bluechat-delivery-list/bluechat-delivery-list.component';
import { BluechatSimpleCarrierDeliveryListComponent } from './components/bluechat-simple-carrier-delivery-list/bluechat-simple-carrier-delivery-list.component';
import { BluechatDeliveryStatusComponent } from './search/bluechat-delivery-status/bluechat-delivery-status.component';
import { BluechatLoadDetailComponent } from './details/bluechat-load-detail.component';
import { BluechatDeliveryDetailPopupComponent } from './details/delivery-detail/bluechat-delivery-detail.component';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
    imports: [
        RouterModule.forChild(BLUECHAT_ROUTES),
        SharedModule,
        QuillModule,
        ReactiveFormsModule,
    ],
  declarations: [
    BluechatSearchComponent,
    BluechatListComponent,
    BluechatFiltersComponent,
    BluechatCarriersUnknownComponent,
    BluechatLoadComponent,
    BluechatLoadStatusComponent,
    BluechatDeliveryComponent,
    BluechatDeliveryListComponent,
    BluechatNoteCreationComponent,
    BluechatMassCreationNoteComponent,
    BluechatCarrierDeliveryListComponent,
    BluechatDeliveryListComponent,
    BluechatSimpleCarrierDeliveryListComponent,
    BluechatDeliveryStatusComponent,
    BluechatLoadDetailComponent,
    BluechatDeliveryDetailPopupComponent
  ],
  providers: [
    BluechatService,
    LoadManagementService,
  ]
})
export class BluechatModule {
}
